
import {
    View,
} from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'

const Ioinformationonline = ({ navigation, route }) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        completeOnline
    } = route.params



    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postiowaonline } = useFormsStore()

    const total =
        Number(values?.Personalallowances) +
        Number(values?.dependentsAllowances) +
        Number(values?.itemizeddeductions) +
        Number(values?.adjustmentsAllowances) +
        Number(values?.childAllowances) + Number(values?.personalExemption)

    const handlesubmit = async (signatureDataURL: string) => {
        const data = {
            essUserKey: intializeStore.initializeData?.userkey,
            entityId: personalstore.personalData?.entityId,
            exemptTax:
                values?.exempttax?.trim()?.toLowerCase() === 'exempt' ? true : false,
            filingStatus: values?.Filingstatus,
            spouseEarning: values?.isspouseEarning == 0 ? false : true,
            year: values?.year ? values?.year : null,
            exemptAsMiltary: values?.exemptasmiltary == 0 ? false : true,
            state: values?.state ? values?.state : '',
            personalAllowances: values?.Personalallowances
                ? values?.Personalallowances
                : null,
            dependentAllowances: values?.dependentsAllowances
                ? values?.dependentsAllowances
                : null,
            itemizedDeductions: values?.itemizeddeductions
                ? values?.itemizeddeductions
                : null,
            adjustmentAllowances: values?.adjustmentsAllowances
                ? values?.adjustmentsAllowances
                : null,
            childAllowances: values?.childAllowances ? values?.childAllowances : null,
            additionalAmount: values?.Additionalamount
                ? values?.Additionalamount
                : null,
            personalExemption: values?.personalExemption ? values?.personalExemption : null,
            totalAmount: total,
            formKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: completeOnline,
            sign: signatureDataURL
        }
        const response: any = await postiowaonline(data)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'IOWA Information'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('IoInformatiomForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",

                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}

export default Ioinformationonline
